import MyApplication from '../common/core/MyApplication'
import AppConnector from '../common/core/AppConnector'
import LocationUtil from '../common/util/LocationUtil'
import AssetsManager from '../common/data/AssetsManager'
import DataManager from '../common/data/DataManager'
import WorksManager from '../common/core/WorksManager'
import AppInfo from '../common/constants/AppInfo'
import LoadingView from '../common/view/Loadingview'
import TransitionView from '../common/view/TransitionView'
import CommonModalView from '../common/view/CommonModalView'
import FrameView from '../common/view/FrameView'
import WorksModel from '../common/model/worksModel'
import StageView from './view/StageView'
import ModalView from './view/ModalView'
import { StageModel } from './data/StageModel'

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    // debug, test パラメータ指定がない場合は、console.log 出力を行わないように
    if (!(LocationUtil.getParam('test') || LocationUtil.getParam('debug')))
    {
      console.log = function () {
          // do nothing.
      };
    }

    console.log('otameshi_Map_20240215');

    //ロックフラグ
    this.isLock = true

    //ワーク中かどうかのフラグ
    this.isWorking = false

    //TransitionView初期化
    TransitionView.init()

    //LoadingView初期化
    LoadingView.init()

    // 致命的なエラーのハンドリング
    window.onerror = (message, file, lineNo, colNo, error) =>
    {
      const title = 'エラーが発生しました。'
      const detail = message ? message.toString() : ''
      const stack = error && error.stack ? error.stack : ''
      this.showFatalError(title, detail, stack)
    }
    //
    window.addEventListener('unhandledrejection', (event) =>
    {
      const title = 'エラーが発生しました。'
      const detail = event.reason && event.reason.message ? event.reason.message : ''
      const stack = event.reason && event.reason.stack ? event.reason.stack : ''
      this.showFatalError(title, detail, stack)
    })
    //
    window.addEventListener('rejectionhandled', (event) =>
    {
      const title = 'エラーが発生しました。'
      const detail = event.reason && event.reason.message ? event.reason.message : ''
      const stack = event.reason && event.reason.stack ? event.reason.stack : ''
      this.showFatalError(title, detail, stack)
    })

    //Config.jsonを読み込み=>コンテンツをロード
    const loader = new PIXI.Loader()
    loader.add('config', 'config.json')
    loader.onError.add(e => {throw new Error(`設定ファイルの読み込みに失敗しました`)})
    loader.load((loader, resources) => {
      DataManager.setData('asset_path', resources.config.data.asset_path)
      DataManager.setData('cdn_asset_path', resources.config.data.cdn_asset_path)
      this.init()
    })
  }

  /**
   * 初期化
   */
  async init()
  {
    //ベースディレクトリ設定
    this.monthly = 202104
    this.course_code = LocationUtil.getParam('course_code')
    this.baseDir = LocationUtil.getDirectory() + this.monthly + '/' + this.course_code + '/'

    //ステージアンロック
    this.unlockStageNum = 2

    //マップの進捗一覧データ取得
    this.mapResults = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]

    //現在のステージ
    this.stageIndex = 0
    if(LocationUtil.getParam('stage'))
    {
      this.stageIndex = parseInt(LocationUtil.getParam('stage'))
    }
    this.playingStageIndex = -1

    //MAP用のconfig.json読み込み
    await AssetsManager.loadConfig('map', this.baseDir);
    this.config = AssetsManager.getConfig('map');

    //正解・不正解用しまジローの素材パス
    DataManager.setData('shimajiro_correct', this.baseDir + 'assets/img/shimajiro_correct.png')
    DataManager.setData('shimajiro_wrong', this.baseDir + 'assets/img/shimajiro_wrong.png')

    //共通素材読み込み
    await AssetsManager.loadCommonAssets();

    //アセット読み込み
    await AssetsManager.loadAssetsByConfig('map', this.baseDir, false);

    //PIXI.js初期化
    this.initPixi();

    //VIEW初期化
    this.initView();

    //コマの表示更新
    this.updateStageView()

    //ページの初期化
    this.pageIndex = 0
    const pageIndex = (this.config.stages[this.stageIndex].pos.x > AppInfo.DESIGN_WIDTH)?1:0
    this.scrollPage(pageIndex, 0)

    //ローディング非表示
    await LoadingView.hide()

    //スタート！
    this.start()
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	VIEWの組み立て
  // ---------------------------------------------------------------------------------------------------------
  
  /**
   * PIXIの初期化
   */
  initPixi()
  {
    //アプリケーション生成
    this.app = MyApplication.getMyApp()

    //コンテンツ用のコンテナ生成
    this.mapRootContainer = new PIXI.Container();
    this.app.stage.addChild(this.mapRootContainer);
  }

  /**
   * VIEW初期化
   */
  initView()
  {
    //マップコンテナ
    this.mapContainer = new PIXI.Container()
    this.mapRootContainer.addChild(this.mapContainer)

    //マップ
    const map = AssetsManager.createSpriteByName('map')
    map.x = -145
    map.y = -137
    this.mapContainer.addChild(map)

    //コマ配置
    this.stageContainer = new PIXI.Container();
    this.mapContainer.addChild(this.stageContainer);
    const len = this.config.stages.length;
    for(let i=0; i<len; i++)
    {
      const stageView = new StageView(i, this.config.stages[i]);
      this.stageContainer.addChild(stageView);
      stageView.on('tap', (e)=>{
        this.onStageSelect(e.target.index)
      })
      stageView.on('click', (e)=>{
        this.onStageSelect(e.target.index)
      })
    }

    //しまじろー配置
    this.shimajiro = AssetsManager.createSpriteByName('map_koma.png');
    this.shimajiro.anchor.set(0.5, 1.0);
    this.shimajiro.x = this.config.stages[this.stageIndex].pos.x;
    this.shimajiro.y = this.config.stages[this.stageIndex].pos.y - 7;
    this.mapContainer.addChild(this.shimajiro);

    //次へボタン
    this.nextBtn = AssetsManager.createSpriteByName('map_next_btn.png')
    this.nextBtn.anchor.set(0.5, 0.5)
    this.nextBtn.x = 1265
    this.nextBtn.y = 695
    this.app.stage.addChild(this.nextBtn)
    this.nextBtn.buttonMode = true
    this.nextBtn.interactive = true
    this.nextBtn.on('tap', ()=>{
      this.scrollPage(1)
    })
    this.nextBtn.on('click', ()=>{
      this.scrollPage(1)
    })

    //前へボタン
    this.prevBtn = AssetsManager.createSpriteByName('map_prev_btn.png')
    this.prevBtn.anchor.set(0.5, 0.5)
    this.prevBtn.x = 69
    this.prevBtn.y = 695
    this.app.stage.addChild(this.prevBtn)
    this.prevBtn.buttonMode = true
    this.prevBtn.interactive = true
    this.prevBtn.visible = false
    this.prevBtn.on('tap', ()=>{
      this.scrollPage(0)
    })
    this.prevBtn.on('click', ()=>{
      this.scrollPage(0)
    })

    //おためしコンテンツ用のコンテナ生成
    this.otameshiRootContainer = new PIXI.Container()
    this.app.stage.addChild(this.otameshiRootContainer)

    //おためし用の背景
    this.otameshiBG = new PIXI.Graphics()
    this.otameshiBG.beginFill(0xFF878A)
    this.otameshiBG.drawRect(0, 0, 100, 100)
    this.otameshiBG.endFill()
    this.otameshiRootContainer.addChild(this.otameshiBG)

    //トップ画面
    this.top = new PIXI.Container()
    this.otameshiRootContainer.addChild(this.top)

    //トップ画面背景
    const topBg = AssetsManager.createSpriteByName('otameshi_top')
    this.top.addChild(topBg)

    //スタートボタン
    this.startButton = AssetsManager.createSpriteByName('otameshi_start_button')
    this.startButton.x = 525
    this.startButton.y = 488
    this.top.addChild(this.startButton)
    this.startButton.buttonMode = true
    this.startButton.on('tap', this.startOtameshiMap.bind(this))
    this.startButton.on('click', this.startOtameshiMap.bind(this))

    //最後の画面
    this.last = new PIXI.Container()
    this.last.visible = false
    this.otameshiRootContainer.addChild(this.last)

    //最後の画面の背景
    const lastBg = AssetsManager.createSpriteByName('otameshi_last')
    lastBg.x = (AppInfo.DESIGN_WIDTH - lastBg.width)/2;
    lastBg.y = (AppInfo.DESIGN_HEIGHT - lastBg.height)/2;
    this.last.addChild(lastBg)

    //閉じるボタン
    this.closeBtn = AssetsManager.createSpriteByName('common_close_btn')
    this.closeBtn.anchor.set(0.5, 0.5)
    this.closeBtn.zIndex = 10
    this.app.stage.addChild(this.closeBtn)
    this.closeBtn.buttonMode = true
    this.closeBtn.interactive = true
    this.closeBtn.on('tap', ()=>{
      if(this.isLock) return
      this.commonModal.show('close')      
    })
    this.closeBtn.on('click', ()=>{
      if(this.isLock) return
      this.commonModal.show('close')      
    })
    this.closeBtn.visible = false

    //マップ用のモーダル配置
    this.modal = new ModalView()
    this.app.stage.addChild(this.modal)

    //共通モーダル配置
    this.commonModal = new CommonModalView()
    this.app.stage.addChild(this.commonModal)
    this.commonModal.on('QUIT', this.onQuit.bind(this))

    //フレーム配置（最前面に配置）
    this.frame = new FrameView()
    this.app.stage.addChild(this.frame)

    //リサイズハンドリング
    window.onresize = this.onResize.bind(this);
    this.onResize();
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	スタート
  // ---------------------------------------------------------------------------------------------------------

  async start()
  {
    //スタートボタン押せるようにする
    this.startButton.interactive = true

  }
  

  //おためし版スタート
  async startOtameshiMap()
  {
    //スタートボタン押せないようにする
    this.startButton.interactive = false

    //トランジション表示
    await TransitionView.show()

    //おためしコンテンツ非表示
    this.otameshiRootContainer.visible = false

    //トランジション非表示
    await TransitionView.hide(0.1)
    TransitionView.reset()

    //マップスタート
    this.startNewStage()
  }



  // ---------------------------------------------------------------------------------------------------------
	// --	進行
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 次のステージに移動
   */
  moveToNextStage()
  {
    //ロック解除
    this.isLock = false

    //ステージをすすめる場合
    if(this.playingStageIndex == this.stageIndex && this.stageIndex < 1)
    {
      //もう一度ロックかける
      this.isLock = true

      //ステージのインデックスを進める
      this.stageIndex ++

      //しまジロー移動
      const model = this.config.stages[this.stageIndex];
      TweenMax.killTweensOf(this.shimajiro);
      TweenMax.to(this.shimajiro, 0.6, {
        x           :model.pos.x,
        y           :model.pos.y - 7,
        delay       :0.5,
        ease        :'power2.inOut',
        onComplete  :()=>{
          this.startNewStage();
        }
      })

      //ページスクロール
      const newPageIndex = (model.pos.x > AppInfo.DESIGN_WIDTH)?1:0
      this.scrollPage(newPageIndex)
    }

    //プレイ中のインデックスをリセット
    this.playingStageIndex = -1
  }
  
  /**
   * 新しいステージをスタート
   */
  startNewStage()
  {
    //しまジローの演出
    TweenMax.killTweensOf(this.shimajiro)
    const baseY = this.shimajiro.y
    TweenMax.to(this.shimajiro, 0.2, {y:baseY - 30})
    TweenMax.to(this.shimajiro, 0.6, {y:baseY, delay:0.2, ease:'bounce.out'})

    //まだチャレンジしていないステージならばモーダル表示
    if(!this.mapResults[this.stageIndex])
    {
      TweenMax.delayedCall(1.5, ()=>{
        const modal = this.config.stages[this.stageIndex].modal
        const model = new StageModel(modal.id, modal.sound)
        this.showModal(model)
      })
    }
    //チャレンジ済みのステージの場合は単純にロック解除
    else
    {
      //ロック解除
      this.isLock = false
    }
  }

  /**
   * ステージの表示更新
   */
  updateStageView()
  {
    const len = this.stageContainer.children.length;
    for(let i=0; i<len; i++)
    {
      const result = this.mapResults[i]
      const koma = this.stageContainer.getChildAt(i);

      if(i < this.unlockStageNum)
      {
        if(result)
        {
          koma.update(2) //挑戦済み
        }
        else
        {
          koma.update(1) //未挑戦
        }
      }
      else
      {
        koma.update(0) //アンロック前
      }
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	モーダル
  // ---------------------------------------------------------------------------------------------------------
  
  /**
   * モーダル表示
   */
  showModal(model)
  {
    this.modal.show(model);
    this.modal.on('MODAL_CLOSE', this.onModalClose.bind(this));
    this.modal.on('MODAL_NEXT', this.onModalNext.bind(this));
  }

  /**
   * 閉じるボタン押された
   */
  onModalClose()
  {
    //リスナー削除
    this.modal.off('MODAL_CLOSE');
    this.modal.off('MODAL_NEXT');

    //モーダル非表示
    this.modal.hide();

    //ロック解除
    this.isLock = false
  }

  /**
   * NEXTボタン押された
   */
  onModalNext()
  {
    //リスナー削除
    this.modal.off('MODAL_CLOSE');
    this.modal.off('MODAL_NEXT');

    //ステージ開始
    this.startStageWorks(this.stageIndex)
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	STAGE
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ステージ選択
   */
  onStageSelect(index)
  {
    //ワーク中は処理なし
    if(this.isWorking || this.isLock) return

    //プレイできるステージ
    if(index <= this.stageIndex)
    {
      this.startStageWorks(index)
    }
    else
    {
      console.log('まだそこまで進んでいません')
    }
  }
  
  /**
   * STAGE開始
   */
  async startStageWorks(index)
  {
    //入力ロック解除
    this.isLock = false

    //ワーク中のフラグ
    this.isWorking = true

    //挑戦するステージのインデックス
    this.playingStageIndex = index

    //トランジション表示
    await TransitionView.show()
    TransitionView.reset()

    //閉じるボタン表示
    this.closeBtn.visible = true

    //ローディング表示
    LoadingView.show()

    //モーダルをリセット
    this.modal.reset()

    //現在のモデル
    const stageModel = this.config.stages[this.playingStageIndex]

    //ステージのWORKS読み込み
    this.loadStageWorks(stageModel)
  }

  /**
   * STAGEのWORKS読み込み
   */
  loadStageWorks(stageModel)
  {
    //Worksの親ディレクトリ
    const worksDir = this.baseDir + ( '000' + stageModel.index ).slice( -3 ) + '/'

    //モデル生成
    const worksModel = new WorksModel(this.baseDir, worksDir, 5, stageModel.finish)

    //移動コンテンツかどうかのフラグ設定
    worksModel.isMove = (stageModel.work_type == 'move')

    //移動コンテンツ用のクラス名
    worksModel.moveClass = 'move_04'

    //ワークスマネージャースタート
    WorksManager.start(worksModel)
    WorksManager.once('FINISH', this.onStageWorksFinish.bind(this))
  }

  /**
   * STAGEのWORKS終了
   */
  async onStageWorksFinish(results)
  {
    //トランジション表示
    await TransitionView.show()

    //結果を配列で保持
    let isPerfect = true
    for(let i=0; i<results.length; i++)
    {
      if(!results[i])
      {
        isPerfect = false
        break
      }
    }
    this.mapResults[this.playingStageIndex] = (isPerfect)?"perfect":"done"

    //コンテンツを破棄
    WorksManager.dispose()

    //閉じるボタン非表示
    this.closeBtn.visible = false

    //終了判定
    const finishFlag = (this.stageIndex >= 1)

    //終了画面表示
    if(finishFlag)
    {
      this.otameshiRootContainer.visible = true
      this.top.visible = false
      this.last.visible = true
    }

    //トランジション非表示
    await TransitionView.hide(0.1)
    TransitionView.reset()

    //マップを進める
    if(!finishFlag)
    {
      //ワーク中のフラグもどす
      this.isWorking = false

      //コマの表示更新
      this.updateStageView()

      //次のステージへ移動
      this.moveToNextStage()
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	やめる場合
  // ---------------------------------------------------------------------------------------------------------

  onQuit()
  {
    if(this.isWorking)
    {
      this.quitWork()
    }
    else
    {
      //アプリ側に閉じる通知
      AppConnector.onClickCloseButton()
    }
  }

  /**
   * ワークを途中終了
   */
  async quitWork()
  {
    //トランジション表示
    await TransitionView.show();

    //共通モーダルをリセット
    this.commonModal.reset()

    //閉じるボタン非表示
    this.closeBtn.visible = false

    //コンテンツを破棄
    WorksManager.off('FINISH')
    WorksManager.dispose()

    //トランジション非表示
    await TransitionView.hide(0.1)
    TransitionView.reset()

    //ワーク中のフラグもどす
    this.isWorking = false

    //ロック解除
    this.isLock = false

    //プレイ中のインデックスをリセット
    this.playingStageIndex = -1
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	スクロール関連
  // ---------------------------------------------------------------------------------------------------------
  
  scrollPage(index, duration = 0.6)
  {
    //ワーク中は処理なし
    if(this.isWorking) return

    //ページインデックス保持
    if(this.pageIndex == index) return
    this.pageIndex = index

    //ボタンを一旦非表示
    this.nextBtn.visible = false
    this.prevBtn.visible = false

    //スクロール
    gsap.killTweensOf(this.mapContainer)
    gsap.to(this.mapContainer, duration, {
      x:-AppInfo.DESIGN_WIDTH * this.pageIndex,
      ease:'power1.inOut',
      onComplete:()=>{
        this.nextBtn.visible = (this.pageIndex == 0)
        this.prevBtn.visible = (this.pageIndex == 1)
      }
    })
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ
	// ---------------------------------------------------------------------------------------------------------

  /**
   * リサイズハンドリング
   */
  onResize()
  {
    //コンテナDOM参照
    const container = document.getElementById('canvas-container');

    //計算
    const wW = container.clientWidth;
    const wH = container.clientHeight;
    const rateW = wW / AppInfo.DESIGN_WIDTH;
    const rateH = wH / AppInfo.DESIGN_HEIGHT;
    const rate = (rateW < rateH)?rateW:rateH;
    let dir = "";

    //縦画面
    if(rateW < rateH)
    {
      this.app.renderer.resize(AppInfo.DESIGN_WIDTH, wH / rate);
      dir = 'portrait';
    }
    //横画面
    else
    {
      this.app.renderer.resize(wW / rate, AppInfo.DESIGN_HEIGHT);
      dir = 'landscape';
    }

    //レイアウト用の計算
    const screenW = this.app.renderer.width
    const screenH = this.app.renderer.height
    const offsetX = (screenW > AppInfo.DESIGN_WIDTH + AppInfo.OFFSET_X*2) ? Math.max(AppInfo.OFFSET_X, (screenW - AppInfo.MAX_BG_WIDTH)/2) : 0
    const offsetY = (screenH > AppInfo.MAX_BG_HEIGHT) ? (screenH - AppInfo.MAX_BG_HEIGHT)/2 : 0

    //センタリング
    this.mapRootContainer.x = (screenW - AppInfo.DESIGN_WIDTH)/2;
    this.mapRootContainer.y = (screenH - AppInfo.DESIGN_HEIGHT)/2;

    //NEXT/BACKボタンの位置
    this.nextBtn.x = screenW - 69 - offsetX
    this.nextBtn.y = this.mapRootContainer.y + 695
    this.prevBtn.x = 69 + offsetX
    this.prevBtn.y = this.nextBtn.y

    //閉じるボタンの位置
    this.closeBtn.x = screenW - 50 - offsetX
    this.closeBtn.y = 50 + offsetY
    
    //センタリング
    this.otameshiRootContainer.x = (screenW - AppInfo.DESIGN_WIDTH)/2
    this.otameshiRootContainer.y = (screenH - AppInfo.DESIGN_HEIGHT)/2

    //おためし背景
    this.otameshiBG.width = screenW
    this.otameshiBG.height = screenH
    this.otameshiBG.x = - this.otameshiRootContainer.x
    this.otameshiBG.y = - this.otameshiRootContainer.y

    //モーダル
    this.modal.resize()

    //フレーム
    this.frame.resize()
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	エラーハンドリング
	// ---------------------------------------------------------------------------------------------------------

  /**
   * 致命的なエラーを表示
   */
  showFatalError(title, detail, stack)
  {
    // console.log('showFatalError')
    // console.log('title:', title)
    // console.log('detail:', detail)
    // console.log('stack:', stack)

    //DOM配置
    let html = '<div class="error-style-2" id="error">'
    html += '<div class="error-wrap">'
    html += '<div><img src="../assets/img/error-shimajiro.png" alt="">'
    html += '<div class="error-static-title">ごめんね　いまは　みれないよ</div>'
    html += '<div class="error-static-text">あとでもういちどためしてね</div>'
    html += '<div class="error-detail-simple" id="error-message"></div>'
    html += '<button onclick="location.reload()">もういちどためす</button>'
    html += '</div>'
    html += '</div>'
    html += '</div>'
    document.body.insertAdjacentHTML('beforeend', html)

    //DOM参照
    this.modal = document.getElementById('error');
    this.message = document.getElementById('error-message');

    //表示
    this.message.innerHTML = detail
    this.modal.classList.add('js-show')
  }

	// ---------------------------------------------------------------------------------------------------------
}

window.onload = () => {
  new App();
}
